import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const state = {
  call_codes : [],
  customer_call_codes: [],
  call_codes_types: [],
  selectedCallCode: {}
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/callcodes/index.js